import { render, staticRenderFns } from "./LashesOptions.vue?vue&type=template&id=35398ae2"
import script from "./LashesOptions.vue?vue&type=script&lang=js"
export * from "./LashesOptions.vue?vue&type=script&lang=js"
import style0 from "./LashesOptions.vue?vue&type=style&index=0&id=35398ae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports